const dialogs: HTMLElement[] = [];
const selector = 'button, [href], input, select, textarea, [tabindex], [contenteditable="true"]';
function focusable(dialog: HTMLElement) {
  return Array.from(dialog.querySelectorAll<HTMLElement>(selector)).filter((element) =>
    element.tabIndex >= 0 && !element.matches(':disabled') && !element.closest('[hidden], [inert], [aria-hidden="true"]') && element.getClientRects().length > 0);
}
/** A single stack keeps a nested sheet's Escape and focus inside that sheet. */
export function attachModalFocus(dialog: HTMLElement, onClose: () => void) {
  const previous = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  dialogs.push(dialog);
  const top = () => dialogs[dialogs.length - 1] === dialog;
  const focusFirst = () => (focusable(dialog)[0] ?? dialog).focus();
  dialog.focus();
  const keydown = (event: KeyboardEvent) => {
    if (!top()) return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); onClose(); return; }
    if (event.key !== 'Tab') return;
    const nodes = focusable(dialog);
    const index = nodes.indexOf(document.activeElement as HTMLElement);
    if (!nodes.length) { event.preventDefault(); dialog.focus(); }
    else if (event.shiftKey && index <= 0) { event.preventDefault(); nodes[nodes.length - 1].focus(); }
    else if (!event.shiftKey && (index < 0 || index === nodes.length - 1)) { event.preventDefault(); nodes[0].focus(); }
  };
  const focusin = (event: FocusEvent) => { if (top() && !dialog.contains(event.target as Node)) focusFirst(); };
  document.addEventListener('keydown', keydown, true);
  document.addEventListener('focusin', focusin);
  return () => {
    const wasTop = top();
    dialogs.splice(dialogs.indexOf(dialog), 1);
    document.removeEventListener('keydown', keydown, true);
    document.removeEventListener('focusin', focusin);
    if (wasTop) {
      const parent = dialogs[dialogs.length - 1];
      if (previous?.isConnected && (!parent || parent.contains(previous))) previous.focus();
      else parent?.focus();
    }
  };
}
